module.exports = __webpack_public_path__ + "static/media/foodbook-logo.7961c12d.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/foodbook-logo.png
// module id = 35
// module chunks = 0